export enum UrlType {
  User = 'user',
  UserByCompany = 'user/company',
  Investigation = 'extensioninvestigation',
  InvestigationExtension = 'extensioninvestigation/extension',
  RootCause = 'rootmap/categorised',
  Extension = 'extension',
  ExtensionCompany = 'extension/company',
  ExtensionCategory = 'extensioncategory/byextension',
  ExtensionCategoryBase = 'extensioncategory',
  ExtensionCategoryQuestion = 'extensionCategoryQuestion',
  ExtensionCategoryQuestionAnswer = 'extensionCategoryQuestionAnswer',
  ExtensionRootCauseAnswer = 'extensionRootCauseAnswer',
  ExtensionRootCauseAnswerByInvestigation = 'extensionRootCauseAnswer/investigation',
  ExtensionPromptByRootCause = 'extensionprompt/byrootcause',
  ExtensionPromptByExtension = 'extensionprompt/byextension',
  ExtensionInfo = 'extensioninfo/byextension',
  ExtensionInfoBase = 'extensioninfo',
  ExtensionInfoItemBase = 'extensioninfoitem',
  Considerations = 'extensioncategoryquestion/considerations',
  ExtensionPrompt = 'extensionPrompt',
  RootCauseBase = 'rootMap',
  ExtensionInfoItemNote = 'extensionInfoItemNote'
}
